<snoots-page-generic
  [toolbarInput]="toolbarV2()"
  [noMargin]="noMargin()"
  [bgClasses]="background"
  [integrationDropPoint]="integrationDropPoint()"
  [integrationEntity]="integrationEntity()"
  [integrationParamsBuilder]="integrationParamsBuilder()"
  [eventsEmitter]="eventsEmitter"
  [disableAbsolute]="disableAbsoluteHeight"
>
  <div
    [class]="`flex flex-1 flex-col ${background || 'bg-slate-50'}`"
    [ngClass]="{ 'rounded-md': rounded, 'py-2': !noPadding }"
  >
    @if (dxToolbarItems && dxToolbarItems.length > 0) {
      <div class="flex" [ngClass]="{ 'p-2': !noPadding }">
        <dx-toolbar
          [items]="dxToolbarItems"
          [class]="background || 'bg-slate-50'"
        ></dx-toolbar>
      </div>
    }

    <div
      [ngClass]="{ flex: PLATFORM === PlatformType.MOBILE }"
      class="relative flex-1"
    >
      <div
        [ngClass]="{
          'absolute inset-0':
            !disableAbsoluteHeight && PLATFORM === PlatformType.DESKTOP,
          'px-2': !noPadding
        }"
      >
        <dx-data-grid
          [keyExpr]="keyExpr"
          [columns]="dxDataGridColumns"
          [remoteOperations]="remoteOperations"
          [height]="'100%'"
          [width]="'100%'"
          [showBorders]="!hideBorders"
          [hoverStateEnabled]="true"
          [wordWrapEnabled]="true"
          [editing]="dxDataGridEditing"
          [showColumnLines]="showColumnLines"
          [showRowLines]="showRowLines"
          [selectedRowKeys]="selectedRowKeys"
          [columnHidingEnabled]="columnHidingEnabled"
          [noDataText]="noDataText"
          [highlightChanges]="false"
          [repaintChangesOnly]="repaintChangesOnly()"
          [loadPanel]="{ enabled: !loadPanelDisabled() }"
          [toolbar]="dxToolbar()"
          [summary]="summary()!"
          [cacheEnabled]="false"
          class="rounded-md overflow-hidden"
          (onRowClick)="onRowClick($event)"
          (onRowPrepared)="rowPrepared.emit($event)"
          (onRowExpanding)="rowExpanding.emit($event)"
          (onRowExpanded)="rowExpanded.emit($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onEditorPreparing)="dataGridOnEditorPreparing($event)"
        >
          @if (summary()?.totalItems) {
            <dxo-data-grid-summary
              [totalItems]="summary()!.totalItems!"
            ></dxo-data-grid-summary>
          }

          @if (!disableSelection) {
            <dxo-selection
              [selectAllMode]="selectAllMode"
              [showCheckBoxesMode]="'always'"
              [deferred]="selectionDeferred"
              mode="multiple"
              [allowSelectAll]="allowSelectAll"
            ></dxo-selection>
          }

          @if (enableMasterDetail) {
            <dxo-master-detail
              [enabled]="showMasterDetail"
              template="masterDetail"
            ></dxo-master-detail>
          }

          <div *dxTemplate="let detail of 'masterDetail'">
            <ng-container
              [ngTemplateOutlet]="ngTemplate"
              [ngTemplateOutletContext]="{ $implicit: detail.data }"
            ></ng-container>
          </div>

          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxo-filter-panel [visible]="showFilterPanel"></dxo-filter-panel>

          <dxo-filter-row [visible]="showFilterRow">
            <dxo-operation-descriptions
              [greaterThanOrEqual]="'Dal giorno' | transloco"
              [between]="'Compresa tra' | transloco"
              [lessThanOrEqual]="'Prima del' | transloco"
            ></dxo-operation-descriptions>
          </dxo-filter-row>

          <dxo-paging [enabled]="true" [pageSize]="pageSize"></dxo-paging>

          <dxo-scrolling
            [useNative]="scrollingUseNative"
            [showScrollbar]="scrollingShowScrollbar"
          ></dxo-scrolling>

          <dxo-pager
            [visible]="!hidePager"
            [allowedPageSizes]="pagerAllowedPageSizes"
            [displayMode]="'full'"
            [showInfo]="true"
            [showNavigationButtons]="true"
            [showPageSizeSelector]="pagerShowPageSizeSelector"
          >
          </dxo-pager>

          <dxo-sorting
            [mode]="disableSorting ? 'none' : 'single'"
          ></dxo-sorting>
        </dx-data-grid>
      </div>
    </div>
  </div>
</snoots-page-generic>
